import axios from '@axios'

export const state = {
  warehouses: [],
  currentPage: 1,
  perPage: 15,
  totalPage: 1,
  totalRecord: 0,
}

export const getters = {
  allWarehouses: (state) => state.warehouses,
  currentPage: (state) => state.currentPage,
  perPage: (state) => state.perPage,
  totalPages: (state) => state.totalPages,
  totalRecords: (state) => state.totalRecords,
}

export const mutations = {
  GET_WAREHOUSES: (state, resp) => {
    if (!resp) return null
    state.warehouses = resp.warehouses
    state.currentPage = resp.page
    state.perPage = resp.perPage
    state.totalPages = resp.totalPages
    state.totalRecords = resp.totalRecords
  },
  DELETE_WAREHOUSE: (state, warehouse) => {
    state.warehouses = state.warehouses.filter((w) => w.id !== warehouse.id)
  },
}

export const actions = {
  async getWarehouses({ commit }, params = {}) {
    await axios
      .get('/api/warehouses', { params: params })
      .then((resp) => {
        if (resp.status === 200) {
          commit('GET_WAREHOUSES', resp.data)
        }
      })
      .catch((err) => {
        commit(
          'GET_WAREHOUSES',
          err.response.status === 404 ? { warehouses: [] } : null
        )
      })
  },
  async createWarehouse({ commit }, warehouse) {
    return axios.post(`/api/warehouses`, warehouse)
  },
  async editWarehouse({ commit }, warehouse) {
    return axios.put(`/api/warehouses`, warehouse)
  },
  async deleteWarehouse({ commit }, warehouse) {
    await axios.delete(`/api/warehouses/${warehouse.id}`).then((resp) => {
      if (resp.status === 204) {
        commit('DELETE_WAREHOUSE', warehouse)
      }
    })
  },
}
